module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info_block",
    attrs: {
      "id": "connect-open-id"
    }
  }, [_c('h4', {
    staticClass: "info_block_heading"
  }, [_vm._v(" " + _vm._s(_vm.$t("profile.open_id.heading")))]), _vm._v(" "), _c('div', {
    staticClass: "mb-24"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap-social-open-id--profile-page"
  }, [_c('FacebookIconText'), _vm._v(" "), _c('GoogleIconText'), _vm._v(" "), _c('AppleIconText')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-884f8fa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-page/impl/open-id/index.vue
// module id = 431
// module chunks = 1